import Core from '../Core'
import { getUuid } from '../initializers/Utils'

import BatchUploader        from '../ressources/BatchUploader'
import BatchUploaderBatifid from '../ressources/BatchUploaderBatifid'

export default (superclass) => class extends superclass {
  // deprecated
  bulkUploadWithFileInput () {
    return Core.publicWrapper({
      name: 'bulkUploadWithFileInput',
      arguments: arguments,
      parameters: ['inputId', 'onProgress', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { type: 'string', name: 'inputId' },
      ],
    }, async function wrapped (params) {
      // TODO: next major
      // drop "inputId" in favor of "files"
      const domInput = global.document.getElementById(params.inputId)
      Core.validateParam('uploadWithFileInput', domInput,
        { presence: true, message: 'no input element #' + params.inputId })
      Core.validateParam('uploadWithFileInput', domInput.files,
        { presence: true, message: 'this input #' + params.inputId + ' is not a file input' })
      Core.validateParam('uploadWithFileInput', domInput.files.length,
        { notEqual: 0, message: 'no file in this input #' + params.inputId })

      const user = Core.getRessource('User')
      if (!user) { throw Core.missingUserError() }

      const uuids = new Set()
      while (uuids.size < domInput.files.length) {
        uuids.add(getUuid({ userId: user.get('id') }))
      }

      return Core.execute('Api', 'bulkUpload', { uuids: Array.from(uuids), files: domInput.files, onProgress: params.onProgress })
    })
  }

  // deprecated
  getBatchUploader () {
    return new BatchUploader()
  }

  // deprecated
  getBatchUploaderBatifid (uuid) {
    return new BatchUploaderBatifid(uuid)
  }

  authorizePartner () {
    return this._publicWrapperWithoutParameter('authorizePartner', arguments)
  }

  uploadFile () {
    return Core.publicWrapper({
      name: 'uploadFile',
      arguments: arguments,
      parameters: ['file', 'capturedAt', 'batchUuid', 'onProgress', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'file', presence: true, klass: global.File },
        { name: 'capturedAt', klass: global.Date },
        { name: 'batchUuid', type: 'string' },
        { name: 'onProgress', type: 'function' },
      ],
    })
  }
}
